import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { TravelListPage } from './TravelListPage';
import { TravelPlannerPage } from './TravelPlannerPage';
import { TravelSettingsPage } from './TravelSettingsPage';
import { TravelInboxPage } from './TravelInboxPage';

export function TravelArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<TravelListPage />} />
        <Route path="/settings" element={<TravelSettingsPage />} />
        <Route path="/inbox" element={<TravelInboxPage />} />
        <Route path="/:tripId" element={<TravelPlannerPage />} />
      </Routes>
    </ArcheLayout>
  );
}
